<script>
import STable from '@components/Table'
import { loadPermissionList, loadUserDriveLogList } from '@/api/data'
import moment from 'moment'
export default {
  name: 'DriveLog',
  components: {
    STable
  },
  data () {
    return {
      drivers: [],
      columns: [
        {
          title: this.$t('user.name'),
          dataIndex: 'name',
          align: 'center',
          width: 160
        },
        {
          title: this.$t('user.account'),
          dataIndex: 'account',
          align: 'center',
          width: 160
        },
        {
          title: this.$t('user.drive.log.start'),
          children: [
            {
              title: this.$t('user.drive.log.time'),
              width: 160,
              dataIndex: 'start_time_t',
              align: 'center'
            },
            {
              title: this.$t('user.drive.log.start_address'),
              dataIndex: 'start_address',
              scopedSlots: { customRender: 'start_address' },
              align: 'center'
            }
          ]
        },
        {
          title: this.$t('user.drive.log.end'),
          children: [
            {
              title: this.$t('user.drive.log.time'),
              dataIndex: 'end_time_t',
              align: 'center'
            },
            {
              title: this.$t('user.drive.log.end_address'),
              dataIndex: 'end_address',
              scopedSlots: { customRender: 'end_address' },
              align: 'center'
            }
          ]
        }
      ],
      height: window.document.body.clientHeight - 250,
      queryObj: {},
      loadData: paramter => {
        return loadUserDriveLogList(Object.assign(this.queryObj, paramter)).then(res => {
          const data = res.result.data
          for (const item of data) {
            item.start_time_t = moment(item.start_time).format('YYYY-MM-DD HH:mm:ss')
            item.start_location = JSON.parse(item.start_location)
            if (item.end_time) {
              item.end_time_t = moment(item.end_time).format('YYYY-MM-DD HH:mm:ss')
              item.end_location = JSON.parse(item.end_location)
            }
          }
          return res.result
        })
      }
    }
  },
  created () {
    loadPermissionList({ pageNo: 1, pageSize: 100 }).then(res => {
      const ds = res.result.data
      this.drivers = ds
      const users = []
      for (const d of ds) {
        users.push(d.user_id)
      }
      this.allDvs = users
      this.queryObj.uid = users
      this.$refs.table.refresh()
    })
  },
  methods: {
    showLocation (location, isPro) {
      if (!isPro) {
        this.$message.error(this.$t('user.test.location.not.pro'))
        return
      }
      window.open('https://www.google.com/maps/place/' + location.loc_gl, '_blank')
    },
    handleChangeDriver (e) {
      if (e) {
        this.queryObj.uid = [e]
      } else {
        this.queryObj.uid = this.allDvs
      }
    },
    search () {
      this.$refs.table.refresh()
    }
  }
}
</script>

<template>
  <div class="drive-log-page">
    <div class="filter-card">
      <div class="filter-card__body">
        <a-row :gutter="16">
          <a-col :xxl="{ span: 6 }" :lg="{ span: 6 }">
            <div class="filter-item">
              <label class="filter-item__label">{{ $t('user.name') }}</label>
              <a-select class="filter-item__input" allowClear @change="handleChangeDriver">
                <a-select-option v-for="driver in drivers" :value="driver.user_id" :key="driver.user_id">{{ driver.name }}</a-select-option>
              </a-select>
            </div>
          </a-col>
          <a-col :lg="{ span: 6 }">
            <div class="filter-item filter-item--actions">
              <a-button type="primary" @click="search">{{ $t('user.action.search') }}</a-button>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
    <div class="table-card">
      <s-table
        ref="table"
        :columns="columns"
        :data="loadData"
        bordered
        size="small"
        :scroll="{ x: 1100, y: height }">
        <div slot="start_address" slot-scope="text, record">
          <a class="location-link" @click="showLocation(record.start_location, record.is_pro)">
            <a-icon type="environment" class="location-link__icon" />
            {{ decodeURIComponent(record.start_location.loc_str) }}
          </a>
        </div>
        <div slot="end_address" slot-scope="text, record">
          <a v-if="record.end_location" class="location-link" @click="showLocation(record.end_location, record.is_pro)">
            <a-icon type="environment" class="location-link__icon" />
            {{ decodeURIComponent(record.end_location.loc_str) }}
          </a>
          <span v-else class="cell-muted">--</span>
        </div>
      </s-table>
    </div>
  </div>
</template>

<style scoped lang="less">
@primary: #52C41A;
@border-color: #e8e8e8;
@text-secondary: rgba(0, 0, 0, 0.45);
@radius: 6px;
@shadow-card: 0 1px 2px rgba(0, 0, 0, 0.06), 0 1px 3px rgba(0, 0, 0, 0.04);
@transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);

.drive-log-page {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.filter-card {
  background: #fff;
  border-radius: @radius;
  box-shadow: @shadow-card;
  overflow: hidden;

  &__body {
    padding: 12px 20px 16px;
  }
}

.filter-item {
  display: flex;
  align-items: center;

  &__label {
    flex-shrink: 0;
    width: 56px;
    font-size: 13px;
    color: @text-secondary;
    text-align: right;
    margin-right: 10px;
    white-space: nowrap;
  }

  &__input {
    flex: 1;
    min-width: 0;
  }

  &--actions {
    display: flex;
    align-items: center;
    gap: 8px;
  }
}

.table-card {
  background: #fff;
  border-radius: @radius;
  box-shadow: @shadow-card;
  padding: 16px 20px;
}

.cell-muted {
  color: @text-secondary;
  font-size: 13px;
}

.location-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: @primary;
  font-size: 13px;
  transition: color @transition;

  &:hover {
    color: darken(@primary, 10%);
  }

  &__icon {
    font-size: 13px;
  }
}

@media (max-width: 768px) {
  .filter-card__body {
    padding: 12px;
  }

  .table-card {
    padding: 12px;
  }
}
</style>
